import { callApi } from "./api.service";

export const PrivateMessageList = async (
  getToken: () => Promise<string | null>
) => {
  return await callApi(
    "/api/private-messages/list",
    "POST",
    true,
    getToken
  );
};

export const MessageMarkAsRead = async (
  getToken: () => Promise<string | null>,
  data: any
) => {
  return await callApi(
    `/api/private-messages/update?sender_id=${data.sender_id}&receiver_id=${data.receiver_id}`,
    "POST",
    true,
    getToken
  );
};
